import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "antd";
import UserFilters from "./usersFilters";
import {
  getUserList,
  userBlockUnblock,
  userUnlock,
} from "../../../apis/usersApis";

const UserList = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    userList();
  }, []);

  const userList = async (searchData = {}) => {
    try {
      const res = await getUserList(searchData);
      if (res.success) {
        setList(res.result);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const handleBlock = async (id) => {
    if (window.confirm("Are you sure you want to block this user?")) {
      try {
        const res = await userBlockUnblock(id, { block: true });
        if (res.success) {
          setList(res.result);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleUnblock = async (id) => {
    if (window.confirm("Are you sure you want to unblock this user?")) {
      try {
        const res = await userBlockUnblock(id, { block: false });
        if (res.success) {
          setList(res.result);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleViewDetails = (id) => {
    navigate(`/login_details/${id}`);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
      width: "10%",
    },
    {
      title: "Name",
      render: (text, record) => (
        <span>
          {record.firstName
            ? `${record.firstName} ${record.middleName || ""} ${
                record.lastName || ""
              }`
            : "--"}
        </span>
      ),
      sorter: (a, b) => {
        const nameA = `${a.firstName} ${a.middleName || ""} ${
          a.lastName || ""
        }`.toLowerCase();
        const nameB = `${b.firstName} ${b.middleName || ""} ${
          b.lastName || ""
        }`.toLowerCase();
        return nameA.length - nameB.length;
      },
      width: "20%",
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length,
      width: "20%",
    },
    {
      title: "Role",
      dataIndex: "role",
      sorter: (a, b) => a.role.length - b.role.length,
      width: "20%",
    },

    {
      title: "View",
      render: (text, record) => (
        <button
          className="btn btn-secondary"
          onClick={() => handleViewDetails(record.id)}
        >
          Login History
        </button>
      ),
      width: "15%",
    },
    // {
    //   title: "Block/Unblock",
    //   render: (text, record) => (
    //     <>
    //       {record.block === false ? (
    //         <button
    //           className="btn btn-danger"
    //           onClick={() => handleBlock(record.id)}
    //         >
    //           Block
    //         </button>
    //       ) : (
    //         <button
    //           className="btn btn-primary"
    //           onClick={() => handleUnblock(record.id)}
    //         >
    //           Unblock
    //         </button>
    //       )}
    //     </>
    //   ),
    //   width: "15%",
    // },
  ];

  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content container-fluid">
          <UserFilters onSearch={userList} />
          {loading ? (
            <div>Loading...</div>
          ) : list && list.length > 0 ? (
            <Table
              columns={columns}
              dataSource={list}
              className="table-striped"
              rowKey={(record) => record.id}
            />
          ) : (
            <div>No Records found</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserList;
